import { toCapitalize, toNormalize } from 'Common/string';
const R = require('ramda');

export const getKey = _ => {
  if (_) {
    const obj = JSON.parse(_);

    if (obj && obj.key) {
      return obj.key;
    }

    return '';
  }
};

export const getDisplay = _ => {
  if (_) {
    const obj = JSON.parse(_);

    if (obj) {
      const displayValue = obj.display;

      return displayValue || obj.key;
    }

    return '';
  }
};

export const getAndFormat = R.compose(toNormalize, getDisplay);

export const createValue = i => {
  const newItem = Object.assign({}, i);
  delete newItem.doc_count;
  return JSON.stringify(newItem);
};

export const bodyTypesMappings = {
  'city-car': 'City Car',
  mpv: 'MPV',
  suv: 'SUV'
};

export const getBodyTypesText = name => {
  return bodyTypesMappings[name] ? bodyTypesMappings[name] : name;
};

export const getActiveFilterButtontext = (fields, key, dealerName) => {
  if (key === 'postCode') return fields[key].toUpperCase();

  if (key === 'keyword') return `"${fields[key]}"`;

  if (getBodyTypesText(getDisplay(fields[key])) !== getDisplay(fields[key]))
    return getBodyTypesText(getDisplay(fields[key]));

  const mappings = {
    minPrice: 'From ' + getDisplay(fields[key]),
    maxPrice: 'To ' + getDisplay(fields[key]),
    withinDistance: R.test(/over /i, getDisplay(fields[key]))
      ? toCapitalize(getDisplay(fields[key]))
      : 'Within ' + getDisplay(fields[key]),
    annualTax:
      'Tax ' +
      (getDisplay(fields[key]) ? getDisplay(fields[key]).toLowerCase() : ''),
    mileage: 'Mileage ' + getDisplay(fields[key]),
    insuranceGroup: 'Insurance ' + getDisplay(fields[key]),
    doors: getDisplay(fields[key]) + ' Doors',
    seats: getDisplay(fields[key]) + ' Seats',
    engineSizeFrom: 'From ' + getDisplay(fields[key]),
    engineSizeTo: 'To ' + getDisplay(fields[key]),
    yearFrom: 'From ' + getDisplay(fields[key]),
    yearTo: 'To ' + getDisplay(fields[key]),
    dealerId: dealerName
  };

  return mappings[key] ? mappings[key] : toCapitalize(getDisplay(fields[key]));
};



// WEBPACK FOOTER //
// ./src/Common/formValues/index.js